import { Field, Label, Description, ErrorMessage } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";
import { Textarea } from "V2.0/common/textarea";
import WaitForCallbackExpectedFields from "./WaitForCallbackExpectedFields";

export default WaitForCallbackForm;

function WaitForCallbackForm(props) {
  const { formState, updateFormState, errors } = props;

  return (
    <div className="space-y-8">
      <Field>
        <Label>Name *</Label>
        <Input
          type="text"
          value={formState.name}
          invalid={!!errors.name}
          onChange={(e) => updateFormState("name", e.target.value)}
        />
        {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Description</Label>
        <Textarea
          type="text"
          value={formState.description}
          rows={3}
          style={{ fontSize: "13px" }}
          onChange={(e) => updateFormState("description", e.target.value)}
        />
      </Field>

      <Field>
        <Label>Callback ID *</Label>
        <Input
          type="text"
          value={formState.callbackId}
          invalid={!!errors.callbacId}
          onChange={(e) => updateFormState("callbackId", e.target.value)}
        />
        {errors.callbackId && <ErrorMessage>{errors.callbackId}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Timeout (seconds) *</Label>
        <Description>Max seconds to wait before timeout</Description>
        <Input
          type="number"
          min={1}
          value={formState.timeoutSeconds}
          onChange={(e) => updateFormState("timeoutSeconds", e.target.value)}
        />
      </Field>

      <div>
        <WaitForCallbackExpectedFields
          expectedFields={formState.expectedFields}
          onUpdateExpectedFields={(expectedFields) =>
            updateFormState("expectedFields", expectedFields)
          }
        />
      </div>
    </div>
  );
}
